import React from 'react'
import { useLocation } from 'react-router-dom'

export function useQuery() {
	const { search } = useLocation()

	return React.useMemo(() => {
		let searchParams = new URLSearchParams(search)
		let params = {}
		for (let pair of searchParams.entries()) {
			params[pair[0]] = pair[1]
		}
		return params
	}, [search])
}

export function formatIDR(num = 0) {
	const formatter = new Intl.NumberFormat('id-ID', {
		style: 'currency',
		currency: 'IDR',
		maximumFractionDigits: 0,
	})

	let formattedNum = formatter.format(num);

	// Remove space between Rp and the number
	formattedNum = formattedNum.replace(/\s/g, '');

	return formattedNum;
}
